import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { useMediaQuery } from "usehooks-ts";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";

import { OrderDetails } from "../../../../../../@types/Orders";
import { OrderStatus } from "../../../../../../enums/Orders";

import { useErrorExpansion } from "./useErrorExpansion";

import styles from "./ErrorMessage.module.css";

interface ErrorMessageProps {
  orderDetails: OrderDetails;
}

export default function ErrorMessage({ orderDetails }: ErrorMessageProps) {
  const { t } = useTranslation();
  const { responsiveDesign } = useTheme();
  const isMobile = useMediaQuery(`(max-width: ${responsiveDesign.sm})`);

  const { isExpanded, setIsExpanded, shouldShowButton, messageRef } =
    useErrorExpansion({
      errorMessage: orderDetails.processMessage,
      isMobile,
    });

  const permittedStatuses = [OrderStatus.ERROR, OrderStatus.UNPROCESSABLE];

  const shouldShowError =
    orderDetails.processMessage &&
    permittedStatuses.includes(orderDetails.processStatus);

  if (!shouldShowError) {
    return null;
  }

  const labelKey = isExpanded ? t("collapse") : t("expand");
  const Icon = isExpanded ? IoChevronUp : IoChevronDown;

  return (
    <div
      className={`${styles.errorMessageContainer} ${
        isExpanded ? styles.expanded : ""
      }`}
    >
      <span className={styles.errorMessage} ref={messageRef}>
        {orderDetails.processMessage}
      </span>
      {shouldShowButton && (
        <button
          className={styles.expandButton}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <p>{labelKey}</p>
          <Icon size={20} />
        </button>
      )}
    </div>
  );
}
